<template>
  <section
    :class="[$style.login, $style.fullscreen]"
    :style="{
      backgroundImage: 'url(\'resources/images/fondo-aol.jpg\')'
    }"
  >
    <header :class="$style.header">
      <a href="javascript: void(0);" :class="$style.logo">
        <img
          src="/resources/images/logo-membresia-aol.png"
          alt="El Arte de Vivir"
        />
      </a>
    </header>
    <div :class="$style.content">
      <div :class="$style.promo">
        <h1 class="mb-3 text-white">
          <span v-if="paymentLink.name">{{ paymentLink.name }}</span>
          <span v-else>Link de Pagos</span>
        </h1>
        <p>
          Para completar el pago ingresa los datos de tu tarjeta de débito o
          crédito.
        </p>
      </div>

      <div :class="$style.formWrapper">
        <transition :name="'slide-right'" mode="out-in" type="animation">
          <div :class="$style.form" v-if="paymentProcessed && !displayError">
            <p :class="$style.formTitle">
              <a-icon type="like" /> Listo! El pago fue realizado con éxito.
              <br />
            </p>
            <div class="login-form">
              <a-button type="primary" href="http://www.elartedevivir.org"
                ><a-icon type="right" /> Continuar Navegando
              </a-button>
            </div>
          </div>
        </transition>

        <div :class="$style.form" v-if="displayError">
          <p :class="$style.formTitle">
            Hubo un error al cargar el link de pagos. <br /><span
              style="font-size:12px"
              >Por favor, volver a intentar.</span
            >
          </p>
        </div>
        <div
          :class="$style.form"
          v-else-if="!paymentProcessed && !displayError"
        >
          <p :class="$style.formTitle">Ingresá tus datos</p>

          <customer-form ref="customerFormComponent" />

          <a-divider orientation="left">Datos de Pago</a-divider>

          <payment-form
            v-if="paymentLink"
            ref="paymentFormComponent"
            :mode="'2-step'"
            :showPrice="true"
            :showInstallments="true"
            :showSubmit="true"
            :publicKey="paymentLink.account.publicKey"
            @cardValidated="handleSubmit"
          >
          </payment-form>
        </div>
        <div :class="$style.sidebar">
          <p :class="$style.sidebarTitle">
            Link de Pagos:
          </p>
          <p :class="$style.sidebarSubTitle" style="line-height:1.3">
            {{ paymentLink.name }}
          </p>

          <p :class="$style.sidebarSubTitle" style="margin-bottom:1rem">
            <strong>Precio:</strong>
            ${{ paymentLink.amount }}
            <span v-if="paymentLink.account.gatewayId == 1">ARS</span>
            <span v-else-if="paymentLink.account.gatewayId == 2">USD</span>
          </p>
          <!--
            <p :class="$style.sidebarSubTitle" style="margin-bottom:1rem">
            <i class="icmn-user mr-3" /> Usuario: <br />
            {{ email }}
            <span v-if="phone"
              ><br />
              Tel: {{ phone }}
            </span>
          </p>
          -->
          <!--<div :class="$style.sidebarFooter" style="margin-bottom:1rem">
            <span>
              <i class="icmn-location mr-3" />
              Argentina
            </span>
          </div>-->
          <div :class="$style.sidebarContent">
            <p>
              <strong>Términos y Condiciones:</strong><br />

              <span v-if="paymentLink.account.gatewayId == 1">
                Los datos ingresados son procesados directamente por el gateway
                de pagos Decidir Prisma<sup>&reg;</sup>. En caso de cambio de
                precios de servicio se notificará a los usuarios con un mes de
                anticipación. Puedes cancelar la suscripción en el momento en el
                que lo desees.
              </span>
              <span v-else>
                Los datos ingresados son procesados directamente por la pasarela
                de pagos Páguelo Fácil<sup>&reg;</sup>. En caso de cambio de
                precios de servicio se notificará a los usuarios con un mes de
                anticipación. Puedes cancelar la suscripción en el momento en el
                que lo desees.
              </span>

              <!--
              Visa, MasterCard, American Express, ArgenCard, BBPS, Cabal, Cabal
              Prisma, CoopePlus, CrediGuia, Credimás, Diners Club, Distribution,
              Favacard, Grupar, Italcred, MasterCard Prisma, Nativa, Nexo,
              Patagonia 365, Qida, Tarjeta Carrefour / Cetelem, Tarjeta
              Cencosud, Tarjeta Club Día, Tarjeta La Anónima, Tarjeta Naranja,
              Tarjeta Nevada, Tarjeta PymeNacion, Tarjeta Shopping, Tarjeta SOL,
              Tuya-->
            </p>
          </div>
        </div>
      </div>
    </div>
    <footer :class="$style.footer" style="text-align:center; margin-top:5rem">
      <span style="color:#ccc;">
        <img
          src="/resources/images/logo-membresia-aol.png"
          alt="El Arte de Vivir"
          width="120"
        /><br />
        <!-- Darregueyra 2390, Palermo Buenos Aires, Argentina.<br /> -->
        <a href="https://elartedevivir.org" target="_blank">elartedevivir.org</a
        ><br />
        Darregueyra 2390, Ciudad Autónoma de Buenos Aires, Argentina.
      </span>
      <!--<ul :class="$style.footerNav">
        <li>
          <a href="javascript: void(0);">Términos y Condiciones</a>
        </li>
        <li>
          <a href="javascript: void(0);">Compliance</a>
        </li>
        <li>
          <a href="javascript: void(0);">Confidencialidad</a>
        </li>
        <li>
          <a href="javascript: void(0);">Soporte</a>
        </li>
        <li>
          <a href="javascript: void(0);">Contacto</a>
        </li>
      </ul>-->
    </footer>
  </section>
</template>

<script>
import { mapActions } from "vuex";
import store from "@/store";
import errors from "@/services/errors";
//import VueRecaptcha from "vue-recaptcha";
import utils from "@/services/utils";
import Vue from "vue";
import gateway from "@/services/gateway";
import PaymentForm from "@/components/PaymentForm";
import CustomerForm from "@/components/CustomerForm";

export default {
  components: {
    //VueRecaptcha,
    PaymentForm,
    CustomerForm
  },
  data: function() {
    return {
      linkToken: this.$route.params.linkToken,
      loading: false,
      submitLoader: false,
      displayError: false,
      paymentProcessed: false,
      paymentLink: null
    };
  },
  methods: {
    ...mapActions({
      loadPaymentLink: "paymentLink/load",
      pay: "paymentLink/pay"
    }),
    handleRecaptchaVerified(key) {
      this.recaptchaKey = key;
    },
    async handleSubmit(paymentFormPayload) {
      this.submitLoader = true;
      this.$refs.paymentFormComponent.enableSubmitLoader();
      const customerFormPayload = await this.$refs.customerFormComponent.handleSubmit();
      const x = 10;
      if (paymentFormPayload && customerFormPayload) {
        let err;
        const x = 10;
        try {
          const response = await this.pay({
            paymentFormPayload,
            customerFormPayload,
            linkToken: this.linkToken
          });

          this.submitLoader = false;
          this.$refs.paymentFormComponent.disableSubmitLoaderWithSuccess();
          window.setTimeout(() => {
            this.paymentProcessed = true;
          }, 1000);

          this.$notification["success"]({
            message: "Exito",
            description: response.message
          });
          //this.backButton();
        } catch (err) {
          console.log(err);
          this.submitLoader = false;
          this.$refs.paymentFormComponent.disableSubmitLoaderWithError();
          let description;

          if (err.message) description = err.message;
          else
            description =
              "Error al realizar el pago. Por favor, intente denuevo.";

          this.$notification["warning"]({
            message: "Error",
            description: description
          });
        }
      }
    },
    goBack() {
      window.history.back();
    },
    handleEmailChange() {
      this.customerValidated = false;
    }
  },
  async mounted() {
    try {
      this.paymentLink = await this.loadPaymentLink(
        this.$route.params.linkToken
      );
      store.state.paymentForm.subtotal = this.paymentLink.amount;
      //this.subtotal = store.state.paymentLink.amount;
      //this.totalAmount = utils.formatPrice(this.paymentLink.amount);
    } catch (error) {
      this.displayError = true;
      this.$notification["warning"]({
        message: "Error",
        description: error.message
      });
    }

    //alert("hola");
    //document.getElementById("email").focus();
    //this.$refs.initial.$el.children[1].focus(); //focus 1st input on page load.
    //this.subtotal = 1000.99;
    //const x = 10;
  }
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
.ant-select-dropdown {
  width: auto;
}
.ant-select-dropdown-menu {
  max-height: auto;
}
</style>

<style lang="css">
.email-search .ant-input-group-addon {
  top: -1px;
}
.ant-input-group-addon {
  color: rgba(0, 0, 0, 0.45);
  background-color: #f4f4f4;
}
.ant-input {
  height: inherit !important;
}
::placeholder {
  /* WebKit browsers */
  color: red;
  opacity: 1 !important;
}
</style>

<style scoped>
.slide-left-enter-to {
  /*transition: opacity 0.2s;
  opacity: 1;*/
}
.slide-left-enter-active {
  animation: slide-in-left 0.1s ease-in-out;
}
.slide-left-leave {
}
.slide-left-leave-to {
  /*transition: opacity 0.1s;
  opacity: 0;*/
}
.slide-left-leave-active {
  animation: slide-out-left 0.2s ease-in-out;
}

@keyframes slide-in-left {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes slide-out-left {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
}

.slide-right-enter-to {
  /*transition: opacity 0.2s;
  opacity: 1;*/
}
.slide-right-enter-active {
  animation: slide-in-right 0.2s ease-in-out forwards;
}
.slide-right-leave {
}
.slide-right-leave-to {
  /*transition: opacity 0.2s;
  opacity: 0;*/
}
.slide-right-leave-active {
  animation: slide-out-right 0.1s ease-in-out forwards;
}

@keyframes slide-in-right {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes slide-out-right {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
}
</style>
